export const predefinedPrompts = [
  "What's the best strategy for attacking on Bind?",
  "How can I improve my aim in Valorant?",
  "Tips for playing Jett effectively.",
  "Best agents for beginners in Valorant.",
  "How to communicate effectively with my team?",
  "Strategies for winning in competitive mode.",
  "How to counter Phoenix's abilities?",
  "Best loadouts for Sage.",
  "Tips for maintaining a high kill-death ratio.",
  "How to master movement in Valorant?"
];
